export default "/images/d88f236e075032a99092d41d187f33c5.avif";